import dispatcher from '../dispatcher';

var elementProto = Object.create(HTMLElement.prototype);

function fadeIn(element, speed, delay) {
	element.style.webkitTransitionProperty =
		element.style.transitionProperty = 'opacity, transform';

	element.style.webkitTransitionDuration =
		element.style.transitionDuration = speed + 's';

	element.style.webkitTransitionDelay =
		element.style.transitionDelay = delay + 's';

	element.style.webkitTransitionTimingFunction =
		element.style.transitionTimingFunction = 'ease, cubic-bezier(0.5, 0, 0.5, 1)';

	element.style.opacity = element._originalOpacity;
	element.style.webkitTransform =
		element.style.transform = 'translateY(0px)';
}

var _handleTrigger = function() {
	var self = this;
	this._paths.forEach(function(path, index) {
		fadeIn(path, 0.6, index * (1 / self._paths.length));
	});
}

elementProto.createdCallback = function() {
	this.handleTrigger = _handleTrigger.bind(this);
}
elementProto.attachedCallback = function() {
	this._svg = this.getElementsByTagName('svg')[0];
	this._paths = Array.prototype.slice.call(this._svg.children);

	this._paths.forEach(function(path, index) {
		path._originalOpacity = parseFloat(getComputedStyle(path).opacity);

		path.style.opacity = 0;
		path.style.transform = 'translateY(5px)';
	});
}
elementProto.detachedCallback = function() {
}

document.registerElement('ico-component', {
	prototype: elementProto
});